<template>
  <v-data-table
    mobile-breakpoint="0"
    :options.sync="teacherTableOptions"
    :server-items-length="totalItems"
    item-key="id"
    :headers="headers"
    :items="teachers"
    :loading="loading"
    loading-text="Đang Tải"
    :footer-props="footerTable"
    sort-by="name"
    @input="$emit('update:selected', $event)"
    disable-sort
  >
    <template v-slot:[`item.name`]="{ item }">
      <CardTeacherName :teacher="item" link />
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip v-if="item.status" label small class="white--text" :color="getColor(item.status)"
        ><span>{{ item.status | teacherStatus }}</span></v-chip
      >
    </template>
    <template v-slot:[`item.ownClasses`]="{ item }">
      <span>{{ item.ownClasses ? item.ownClasses.length : 0 }}</span>
    </template>
    <template v-slot:[`item.subjectGroup.title`]="{ item }">
      {{ item | _get('subjectGroup.title', 'Chưa có') }}
    </template>
    <template v-slot:[`item.dob`]="{ item }">
      {{ item | _get('dob') | ddmmyyyy }}
    </template>
    <template v-slot:[`item.gender`]="{ item }">
      {{ item.gender | gender }}
    </template>
    <template v-slot:[`item.academicLevels`]="{ item }">
      {{ item | getAcademicLevels }}
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <TeacherListActions :teacher="item" />
    </template>
  </v-data-table>
</template>

<script>
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'
import TeacherListActions from '@/modules/teacher/TeacherListActions'
import { mapActions, mapState } from 'vuex'
const originHeaders = [
  {
    text: 'Giáo viên',
    value: 'name',
    show: true,
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
    show: true,
  },
  {
    text: 'Giới tính',
    value: 'gender',
    show: true,
    width: 100,
  },
  {
    text: 'Bộ môn',
    value: 'academicLevels',
    show: true,
  },
  {
    text: 'Trạng thái',
    value: 'status',
    show: true,
    width: 100,
  },
  {
    text: 'Số lớp dạy',
    value: 'teachingClassCount',
    align: 'center',
    show: true,
  },
  {
    text: 'Số lớp chủ nhiệm',
    value: 'ownClasses',
    align: 'center',
    show: true,
  },
  {
    text: 'Thao tác',
    align: 'right',
    value: 'action',
    show: true,
  },
]

export default {
  components: {
    TeacherListActions,
    CardTeacherName,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      headers: originHeaders,
      teacherTableOptions: {},
      teachings: [],
    }
  },
  computed: {
    ...mapState('teachers', ['teachers', 'totalItems', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số dòng mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  methods: {
    ...mapActions('teachers', ['searchTeachers', 'requestPageSettings']),
    ...mapActions('teaching', ['fetchTeachings']),
    getColor(status) {
      if (status === 'active') return '#46BE8A'
      if (status === 'left') return 'red'
      else return 'orange'
    },
  },
  filters: {
    getAcademicLevels(teacher) {
      if (teacher.academicLevels && teacher.academicLevels.length) {
        return teacher.academicLevels.map(a => a.title).join(', ')
      } else {
        return ''
      }
    },
  },
  watch: {
    teacherTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>
